module.exports = __webpack_public_path__ + "img/part3-11.7921c4e1.png";